<nz-layout>
  <nz-content>
    <!-- ALLERGIES -->
    <app-reusable-table title="Allergies" [columns]="['Date', 'Name', 'Code','Code System','Status']"
      [rowFields]="['effectiveLow','name','code','codeSystem','status']" [data]="data?.allergies?.getAll"
      [dataGetList]="data?.allergies" [isLoading]="isLoading" [isPreview]="true" />

      <!-- PROBLEMS -->
      <app-reusable-table title="Problems" [columns]="['Start Date','End Date','Name','Code','Code System','Status']"
        [rowFields]="['effectiveLow','effectiveHigh','name','code','codeSystem','status']"
        [data]="data?.problems?.getAll" [dataGetList]="data?.problems" [isLoading]="isLoading" [isPreview]="true" />

        <!-- MEDICATIONS -->
        <app-reusable-table title="Medications"
          [columns]="['Start Date','End Date','Name','Code','Code System','Status']"
          [rowFields]="['effectiveLow','effectiveHigh','name','code','codeSystem','status']"
          [data]="data?.medications?.getAll" [dataGetList]="data?.medications" [isLoading]="isLoading"
          [isPreview]="true" />

          <!-- PROCEDURES -->
          <app-reusable-table title="Procedures"
            [columns]="['Start Date','End Date','Name', 'Code','Code System','Status']"
            [rowFields]="['effectiveLow','effectiveHigh','name','code','codeSystem','status']"
            [data]="data?.procedures?.getAll" [dataGetList]="data?.procedures" [isLoading]="isLoading"
            [isPreview]="true" />

            <!-- MEDICAL DEVICES -->
            <app-reusable-table title="Medical Devices"
              [columns]="['Start Date','End Date','Name','Code','Code System','Status']"
              [rowFields]="['effectiveLow','effectiveHigh','name','code','codeSystem','status']"
              [data]="data?.medicalDevices?.getAll" [dataGetList]="data?.medicalDevices" [isLoading]="isLoading"
              [isPreview]="true" />

              <!-- VACCINATIONS -->
              <app-reusable-table title="Vaccinations"
                [columns]="['Start Date','End Date','Name', 'Code','Code System','Status']"
                [rowFields]="['effectiveLow','effectiveHigh', 'name','code','codeSystem','status']"
                [data]="data?.vaccinations?.getAll" [dataGetList]="data?.vaccinations" [isLoading]="isLoading"
                [isPreview]="true" />

                <!-- PREGNANCY -->
                <!-- STATUS -->
                @if (patientInfo?.gender?.toLowerCase() == 'female') {
                  <app-reusable-table title="Pregnancy Status"
                    [columns]="['Date', 'Name','Code', 'Code System','Status']"
                    [rowFields]="['date','name','code','codeSystem','status']" [data]="data?.pregnancyModels?.statusData"
                    [isLoading]="isLoading" [isPreview]="true" />
                }

                <!-- OUTCOME -->
                @if (patientInfo?.gender?.toLowerCase() == 'female') {
                  <app-reusable-table title="Pregnancy Outcome"
                    [columns]="['Name','Code','Code System','Status','Value']"
                    [rowFields]="['name','code','codeSystem','status','value']" [data]="data?.pregnancyModels?.outcomeData"
                    [isLoading]="isLoading" [isPreview]="true" />
                }

                <!-- HISTORY -->
                @if (patientInfo?.gender?.toLowerCase() == 'female') {
                  <app-reusable-table title="Pregnancy History"
                    [columns]="['Code','Code System','Status Code','Value']"
                    [rowFields]="['code','codeSystem','status','value']" [data]="data?.pregnancyModels?.historyData"
                    [isLoading]="isLoading" [isPreview]="true" />
                }

                <!-- SOCIAL HISTORY -->
                <app-reusable-table title="Social History"
                  [columns]="['Start Date','End Date','Name', 'Code','Code System','Status']"
                  [rowFields]="['effectiveLow','effectiveHigh', 'name','code','codeSystem','status']"
                  [data]="data?.socialHistory" [isLoading]="isLoading" [isPreview]="true" />

                  <!-- CARE PLANS -->
                  <app-reusable-table title="Health Care Plans" [columns]="['Date','Description']"
                    [rowFields]="['dateAdded','description']" [data]="data?.carePlans" [isLoading]="isLoading"
                    [isPreview]="true" />
                  </nz-content>
                </nz-layout>